import { z } from 'zod';

/**
 * Zod schema for ESG data query parameters.
 */
export const zodEsgDataQueryParamsSchema = z.object({
  accRefId: z.string().default(''),
  orgUnitId: z.string().default(''),
  sellerId: z.string().default(''),
  siteId: z.string().default(''),
  year: z.number().default(new Date().getFullYear()),
});

/**
 * Zod schema for a single ESG data row from the API (ItemEsgValue).
 * Uses category levels (cat_lv1, cat_lv2) for hierarchical grouping.
 */
export const zodEsgDataRowSchema = z.object({
  calcGwpTotal: z.number(),
  catLv1: z.string(),
  catLv2: z.string(),
  unit: z.string(),
  validFrom: z.number().int().nullish(), // e.g. 2026
  validTill: z.number().int().nullish(), // e.g. 2029
});

/**
 * Zod schema for the ESG data API response (EsgValuesResponse).
 * Returns an object with dataset (array of ItemEsgValue) and fields (array of field names).
 */
export const zodEsgDataResponseSchema = z.object({
  dataset: z.array(zodEsgDataRowSchema),
});
